import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuSharpIcon from '@mui/icons-material/MenuSharp';
import { Menu as MenuIcon, ExpandLess, ExpandMore } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PublicIcon from '@mui/icons-material/Public';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import BusinessIcon from '@mui/icons-material/Business';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { sidebarProcurement } from './layoutData';

// Custom styled tooltip
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#de6b14',
    color: '#fff',
    fontSize: '12px',
    padding: '6px 12px',
    borderRadius: '4px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    fontWeight: 400,
  },
  '& .MuiTooltip-arrow': {
    color: '#de6b14',
  },
}));

const SidebarProcurement = ({ userEmail = 'user@example.com' }) => {
  const [open, setOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState({});

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const renderItem = (item, isSubmenu = false, level = 0) => (
    <Box key={`${item.name}-${item.link || item.path}`}>
      {item.submenu ? (
        <>
          <ListItem
            button
            onClick={() => toggleSubmenu(item.name)}
            sx={{
              pl: 2 + level * 2, // Indent based on submenu level
              color: 'white',
              backgroundColor: isSubmenu ? '#e88a3a' : 'transparent',
              cursor: 'pointer',
              '& .MuiListItemIcon-root': {
                color: 'white',
                minWidth: '25px',
              },
              '& .MuiListItemText-root': {
                marginLeft: open ? '8px' : 0,
              },
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            {open && <ListItemText primary={item.name} />}
            {open && (submenuOpen[item.name] ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
          <Collapse in={submenuOpen[item.name]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.submenu.map((subItem) => renderItem(subItem, true, level + 1))}
            </List>
          </Collapse>
        </>
      ) : (
        <CustomTooltip
          title={item.name}
          placement="right"
          arrow
          disableHoverListener={open}
        >
          <ListItem
            button
            component={NavLink}
            to={item.link || item.path}
            className={({ isActive }) => (isActive ? 'active' : '')}
            sx={{
              pl: 2 + level * 2, // Indent based on submenu level
              color: 'white',
              backgroundColor: isSubmenu ? '#e88a3a' : 'transparent',
              cursor: 'pointer',
              '& .MuiListItemIcon-root': {
                color: 'white',
                minWidth: '25px',
              },
              '& .MuiListItemText-root': {
                marginLeft: open ? '8px' : 0,
              },
              '&.active': {
                backgroundColor: 'white',
                color: '#de6b14',
                '& .MuiListItemIcon-root': {
                  color: '#de6b14',
                },
              },
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            {open && <ListItemText primary={item.name} />}
          </ListItem>
        </CustomTooltip>
      )}
    </Box>
  );

  const renderMenu = (menu) =>
    menu.map((item, index) => (
      <Box key={`${item.name}-${index}`}>
        {renderItem(item, false, 0)}
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)', marginY: (theme) => theme.spacing(0.5) }} />
      </Box>
    ));

  return (
    <div className="flex">
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#333' }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="toggle navigation menu"
            onClick={toggleDrawer}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <CustomTooltip title={userEmail} placement="right" arrow>
            <IconButton color="inherit" aria-label="user email">
              <span className="text-sm">{userEmail}</span>
            </IconButton>
          </CustomTooltip>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: open ? 240 : 60,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: open ? 240 : 60,
            boxSizing: 'border-box',
            transition: 'width 0.3s ease',
            marginTop: '64px',
            backgroundColor: '#de6b14',
            color: 'white',
          },
        }}
      >
        <List>
          <ListItem
            button
            onClick={toggleDrawer}
            sx={{
              backgroundColor: open ? 'rgba(0,0,0,0.1)' : 'transparent',
              color: 'white',
              '& .MuiListItemText-root': {
                marginLeft: open ? '12px' : 0,
              },
            }}
          >
            <CustomTooltip title="Navigation menu" placement="right" arrow>
              <MenuSharpIcon />
            </CustomTooltip>
          </ListItem>
          {renderMenu(sidebarProcurement.amtpl_procurement)}
        </List>
      </Drawer>
    </div>
  );
};

export default SidebarProcurement;